import { Directive, HostListener, ElementRef, Renderer2, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appHighlightOnActive]'
})
export class HighlightOnActiveDirective implements OnChanges {

  @Input() appHighlightOnActive: boolean | '' = true;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['appHighlightOnActive']) {
      const currentValue = changes['appHighlightOnActive'].currentValue;
      
      if (!currentValue) {
        this.renderer.removeClass(this.el.nativeElement, 'select-active');
      }
    }
  }

  @HostListener('focus') onFocus() {
    if (this.appHighlightOnActive) {
      this.renderer.addClass(this.el.nativeElement, 'select-active');
    }
  }

  @HostListener('blur') onBlur() {
    if (this.appHighlightOnActive) {
      this.renderer.removeClass(this.el.nativeElement, 'select-active');
    }
  }

  @HostListener('click') onClick() {
    if (this.appHighlightOnActive) {
      this.renderer.addClass(this.el.nativeElement, 'select-active');
    }
  }

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: HTMLElement) {
    if (this.appHighlightOnActive && !this.el.nativeElement.contains(target)) {
      this.renderer.removeClass(this.el.nativeElement, 'select-active');
    }
  }
}